<div class="hz-line" [style.color]="color">
  <span class="hz-line__left"></span>
  <span class="hz-line__title-wrapper">
    <span class="hz-line__title">
      {{ title }}
    </span>
  </span>
  <span class="hz-line__right"></span>
</div>
